export default function(ngModule) {
    ngModule.factory('Order', function(BaseClass,$q, $http,Product, Ticket, MetaData, Locales) {
        function Order(attr) {
            _.assign(this, attr);
        }
        Order.modelName = 'Order';

        BaseClass.apply(Order);
        Order.configureApi('/order/:guid');

        Order.validates({
            email: {
                format: { email: true },
                required: true
            },
            firstName: { required: true },
            lastName: { required: true },
            locale: {
                inclusion: {
                    in: _.map(Locales, 'code')
                },
                required: true
            }
        });

        Order.getPublic = function(guid) {
            if(!guid || !guid.length)
                return $q.reject('Invalid guid');
            let order = Order.cached.where({ guid: guid });
            if(order.length)
                return $q.resolve(order[0]);
            return $http.get(ORDER_API_ROOT + `/order/${ guid }?conversions=1`)
                .then(res => Order.new(res.data));
        };

        Order.prototype.ticketDownloadReady = function() {
            return $http.get(ORDER_API_ROOT + '/order/' + this.guid).then(res => {
                let order = res.data;

                if(/(cancelled|partially_refunded|fully_refunded|swapped|expired)/.test(order.status))
                    return $q.reject(new Error('cancelled'));

                if(/(pending|partially_paid)/.test(order.status) || !order.download_ready)
                    return $q.reject(new Error('processing'));

                return $q.resolve(order);
            });
        };

        return Order;
    });
}
